<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterOverage"
              :editedCustomerIndex="-1"
              :customerName="'quotation_shortname'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_item_month_number')"
              v-model="filterOverage.MonthNumber"
              @input="getOverageList"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterOverage.LicensePlate"
              @input="getOverageList"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="overageDataTableHeaders"
      :items="overageList"
      class="elevation-1  mt-5"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :loading="isLoadingOverage"
      :loading-text="$t('common_get_data')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>月租預繳功能</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowEditOverageDialog" fullscreen persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2 ml-8" v-bind="attrs" v-on="on">
                {{ $t('common_new') }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ overageDialogTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <ValidationObserver ref="dialogOverage">
                    <v-row>
                      <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                        <customer-autocomplete
                          :fatherEditedCustomer="editedOverage"
                          :editedCustomerIndex="-1"
                          :customerName="'quotation_customer_number'"
                          :isAllTextFieldDisable="isAllTextFieldDisable"
                          @setCustomer="setCustomer"
                          v-if="editedOverageIndex === -1"
                          refName="customerAutocomplete"
                          @keyupEnter="focusNextInput"
                        />
                        <ValidationProvider
                          :name="$t('quotation_customer_number')"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedOverage.CustomerNumber"
                            :label="$t('quotation_customer_number')"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_customer_number') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                        <ValidationProvider
                          :name="$t('quotation_shortname')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedOverage.CustomerName"
                            :label="$t('quotation_shortname')"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_shortname') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                        <ValidationProvider
                          :name="$t('quotation_full_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedOverage.CustomerFullName"
                            :label="$t('quotation_full_name')"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_full_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                        <ValidationProvider
                          :name="$t('quotation_license_plate')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model.trim="editedOverage.LicensePlate"
                            :label="$t('quotation_license_plate')"
                            :error-messages="errors[0]"
                            required
                            clearable
                            :disabled="isAllTextFieldDisable || isLookMode"
                            @keyup.enter="focusNextInput"
                            @change="getMonthList"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_license_plate') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <div v-if="monthItemList.length > 0">
                      <v-row>
                        <v-col cols="12" sm="3" md="3" xl="3" lg="3"
                          ><v-checkbox
                            v-model="editedOverage.IsRepeat"
                            :label="$t('discount_item_repeat')"
                            :disabled="isAllTextFieldDisable || isLookMode"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                          <ValidationProvider
                            :name="$t('discount_item_repeat_warranty_period')"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="editedOverage.IsRepeat"
                          >
                            <v-text-field
                              v-model="editedOverage.RepeatWarrantyPeriod"
                              v-if="editedOverage.IsRepeat"
                              @keyup.enter="focusNextInput"
                              :error-messages="errors[0]"
                              :disabled="isAllTextFieldDisable || isLookMode"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('discount_item_repeat_warranty_period') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                          <item-for-discount-month-autocomplete
                            :editedItemIndex="editedOverageIndex"
                            :itemName="'quotation_item_number'"
                            :monthItemList="monthItemList"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            @setEditedItem="setMonthItem"
                            v-if="editedOverageIndex === -1"
                            refName="itemAutocomplete"
                            @keyupEnter="focusNextInput"
                          />
                          <v-text-field
                            v-model="editedOverage.MonthItemNumber"
                            disabled
                            :label="$t('quotation_item_number')"
                            v-else
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                          <ValidationProvider
                            :name="$t('quotation_item_name')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedOverage.MonthItemName"
                              disabled
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('quotation_item_name') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                          <date-picker-required
                            :dateName="'discount_item_title_time'"
                            :isAllTextFieldDisabled="isAllTextFieldDisable"
                            @setDate="setStartTime"
                            @keyupEnter="focusNextInput"
                            v-if="editedOverageIndex === -1"
                          />
                          <ValidationProvider
                            :name="$t('discount_item_title_time')"
                            rules="required"
                            v-slot="{ errors }"
                            v-else
                          >
                            <v-text-field
                              v-model="computeStartTime"
                              required
                              disabled
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('discount_item_title_time') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                          <ValidationProvider
                            :name="$t('discount_item_use_warranty_period')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              v-model="editedOverage.UseWarrantyPeriods"
                              :items="allWarrantyPeriod"
                              multiple
                              small-chips
                              :disabled="isAllTextFieldDisable || isLookMode"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_data')"
                              @keydown.enter="setKeyDownAutocomplete"
                              @keyup.enter="setKeyUpAutocomplete"
                              ref="useWarrantyPeriodsAutocomplete"
                              :error-messages="errors[0]"
                              @change="setGiveWarrantyPeriod"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('discount_item_use_warranty_period') }}
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                          <ValidationProvider
                            :name="$t('discount_item_prepayment')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedOverage.GivePrepayment"
                              @keyup.enter="focusNextInput"
                              :error-messages="errors[0]"
                              :disabled="isAllTextFieldDisable || isLookMode"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('discount_item_prepayment') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-textarea
                          outlined
                          :label="$t('quotation_item_remark')"
                          v-model="editedOverage.Remark"
                          :disabled="isAllTextFieldDisable || isLookMode"
                        ></v-textarea>
                      </v-row>
                    </div>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-data-table
                :headers="groupTitle"
                hide-default-header
                hide-default-footer
                :items="editedOverage.GroupOverageList"
                single-expand
                item-key="Sort"
                :expanded.sync="expanded"
                class="elevation-1 mx-5"
                :no-data-text="$t('common_no_data')"
                :no-results-text="$t('common_no_results')"
                disable-pagination
                v-if="isLookMode"
              >
                <template v-slot:item="{ item, expand, isExpanded, index }">
                  <tr>
                    <td class="text-start">
                      {{ combineText(item) }}
                    </td>
                    <td class="text-end">
                      <v-icon @click="closeExpandRow(expand, isExpanded)" v-if="isExpanded">
                        mdi-chevron-up
                      </v-icon>
                      <v-icon @click="openExpandRow(expand, isExpanded, index, item)" v-else>
                        mdi-chevron-down
                      </v-icon>
                    </td>
                  </tr>
                </template>

                <template v-slot:expanded-item="{ item, headers }">
                  <td :colspan="headers.length" style="background-color: white;">
                    <v-tabs>
                      <v-tab href="#tab-1">預收條件明細</v-tab>
                      <v-tab href="#tab-2">預收活動紀錄</v-tab>
                      <v-tab-item value="tab-1">
                        <v-data-table
                          :headers="groupOverageItemDataTableHeaders"
                          :items="item.GroupOverageItemList"
                          class="ma-2"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_data')"
                          :no-results-text="$t('common_no_results')"
                          :footer-props="{
                            'items-per-page-options': [30, 50, 100],
                            'items-per-page-text': $t('item_rows_per_page'),
                          }"
                          :header-props="headerProps"
                        >
                          <!-- <template v-slot:[`item.Edit`]="{ index, item }"> -->
                          <!-- 已銷帳、尚未到銷帳時間、尚未產生收款單，都不能讓按鈕觸發 -->
                          <!-- <v-btn
                              color="primary"
                              text
                              :disabled="
                                item.IsCheckUse ||
                                  !item.IsAchieve ||
                                  !editedGroupSortObj.IsThrowOrder
                              "
                              @click="isShowCheckUseOverageDialogBtn(index, item)"
                            >
                              確認已用預收款銷帳
                            </v-btn>
                          </template> -->
                        </v-data-table>
                        <!-- <v-dialog
                          v-model="isShowCheckUseOverageDialog"
                          max-width="500px"
                          persistent
                        >
                          <v-card>
                            <v-card-title> </v-card-title>
                            <v-card-text>
                              <v-container>
                                <ValidationObserver ref="checkUseOverage">
                                  <v-row>
                                    <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                                      <ValidationProvider
                                        name="銷帳的收款單單號"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <v-text-field
                                          v-model="editedGroupOverageItem.UseSaleNumber"
                                          :error-messages="errors[0]"
                                          :disabled="isAllTextFieldDisable"
                                        >
                                          <template v-slot:label>
                                            <span class="red--text">
                                              <strong>* </strong>
                                            </span>
                                            銷帳的收款單單號
                                          </template>
                                        </v-text-field>
                                      </ValidationProvider>
                                    </v-col>
                                  </v-row>
                                </ValidationObserver>
                              </v-container>
                            </v-card-text>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="red darken-1"
                                text
                                @click="closeCheckUseOverage"
                                :disabled="isAllTextFieldDisable"
                              >
                                {{ $t('common_cancel') }}
                              </v-btn>
                              <v-btn
                                color="green darken-1"
                                text
                                @click="saveCheckUseOverage"
                                :loading="isLoadingSaveBtn"
                              >
                                {{ $t('common_save') }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog> -->
                      </v-tab-item>
                      <v-tab-item value="tab-2">
                        <v-data-table
                          :headers="computedOverageRecordDataTableHeaders"
                          :items="item.ComputedOverageRecordList"
                          class="ma-2"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_data')"
                          :no-results-text="$t('common_no_results')"
                          :footer-props="{
                            'items-per-page-options': [30, 50, 100],
                            'items-per-page-text': $t('item_rows_per_page'),
                          }"
                          :header-props="headerProps"
                        >
                          <template v-slot:[`item.StartTime`]="{ item }">
                            {{ convertToDateTimeFormat(item.StartTime) }}
                          </template>
                          <template v-slot:[`item.EndTime`]="{ item }">
                            {{ convertToDateTimeFormat(item.EndTime) }}
                          </template>
                        </v-data-table>
                      </v-tab-item>
                    </v-tabs>
                  </td>
                </template>
              </v-data-table>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditDiscountDialog"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  v-if="!isLookMode"
                  color="green darken-1"
                  text
                  @click="saveOverage"
                  :loading="isLoadingSaveBtn"
                >
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteOverageDialog"
            :deleteMessage="'bom_delete_dialog_message'"
            @closeDelete="closeDeleteOverage"
            @confirmDelete="confirmDeleteDiscount"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.StartTime`]="{ item }">
        {{ convertToDateTimeFormat(item.StartTime) }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditOverageDialogBtn(item)">
          <v-icon small>
            mdi-eye
          </v-icon>
        </v-btn>
        <!-- <v-icon small @click="isShowDeleteOverageDialogBtn(item)">
          mdi-delete
        </v-icon> -->
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { HttpOverage, HttpMonth } from '@/js/http-Manager'
import DatePickerRequired from '@/components/DatePickerRequired.vue'
import ItemForDiscountMonthAutocomplete from '@/components/ItemForDiscountMonthAutocomplete.vue'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'

export default {
  components: {
    CustomerAutocomplete,
    DeleteDialog,
    DatePickerRequired,
    ItemForDiscountMonthAutocomplete,
    CustomerAutocompleteFilter
  },
  name: 'Overage',

  data: () => ({
    expanded: [],
    overageList: [],
    isLoadingOverage: false,
    isShowEditOverageDialog: false,
    editedOverage: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      MonthId: '',
      MonthNumber: '',
      MonthWarrantyPeriod: 0,
      MonthItemId: '',
      MonthItemName: '',
      MonthItemNumber: '',
      StartTime: 0,
      IsRepeat: false,
      RepeatWarrantyPeriod: 0,
      RepeatDay: 0,
      GivePrepayment: 0,
      GiveDay: 0,
      UseWarrantyPeriods: [],
      UseOnDays: [],
      Remark: '',
      GroupOverageList: []
    },
    defaultOverage: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      MonthId: '',
      MonthNumber: '',
      MonthWarrantyPeriod: 0,
      MonthItemId: '',
      MonthItemName: '',
      MonthItemNumber: '',
      StartTime: 0,
      IsRepeat: false,
      RepeatWarrantyPeriod: 0,
      RepeatDay: 0,
      GivePrepayment: 0,
      GiveDay: 0,
      UseWarrantyPeriods: [],
      UseOnDays: [],
      Remark: '',
      GroupOverageList: []
    },
    editedOverageIndex: -1,
    isAllTextFieldDisable: false,
    isLoadingSaveBtn: false,
    isShowDeleteOverageDialog: false,
    tempUseWarrantyPeriods: [],
    isShowEditGroupOverageItemDialog: false,
    searchOverageRecord: '',
    editedGroupOverItemIndex: -1,
    editedGroupOverageItem: {
      IsAchieve: false,
      UseWarrantyPeriod: 0,
      UseOnDay: 0,
      IsCheckUse: false,
      UseSaleNumber: ''
    },
    defaultGroupOverageItem: {
      IsAchieve: false,
      UseWarrantyPeriod: 0,
      UseOnDay: 0,
      IsCheckUse: false,
      UseSaleNumber: ''
    },
    monthItemList: [],
    isShowCheckUseOverageDialog: false,
    editedGroupSortObjIndex: -1,
    editedGroupSortObj: {
      Sort: 0,
      IsThrowOrder: false,
      OverageOrderNumber: '',
      OverageSettleNumber: '',
      OveragePrepaidNumber: '',
      IsAchieveDay: false,
      OverageStartTime: 0,
      TotalUseDay: 0,
      ComputedOverageRecordList: [],
      GroupOverageItemList: []
    },
    defaultGroupSortObj: {
      Sort: 0,
      IsThrowOrder: false,
      OverageOrderNumber: '',
      OverageSettleNumber: '',
      OveragePrepaidNumber: '',
      IsAchieveDay: false,
      OverageStartTime: 0,
      TotalUseDay: 0,
      ComputedOverageRecordList: [],
      GroupOverageItemList: []
    },
    currentOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    totalRows: 0,
    filterOverage: {
      MonthNumber: '',
      CustomerId: '',
      LicensePlate: ''
    }
  }),
  computed: {
    overageDataTableHeaders () {
      return [
        { text: this.$t('quotation_customer_number'), value: 'CustomerNumber', sortable: false },
        { text: this.$t('quotation_shortname'), value: 'CustomerName', sortable: false },
        { text: this.$t('quotation_full_name'), value: 'CustomerFullName', sortable: false },
        { text: this.$t('quotation_license_plate'), value: 'LicensePlate' },
        { text: this.$t('quotation_item_number'), value: 'MonthItemNumber', sortable: false },
        { text: this.$t('quotation_item_name'), value: 'MonthItemName', sortable: false },
        { text: this.$t('quotation_item_month_number'), value: 'MonthNumber' },
        { text: this.$t('discount_item_repeat'), value: 'IsRepeat', sortable: false },
        {
          text: this.$t('discount_item_repeat_warranty_period'),
          value: 'RepeatWarrantyPeriod',
          sortable: false
        },
        { text: this.$t('discount_item_prepayment'), value: 'GivePrepayment', sortable: false },
        { text: this.$t('discount_item_title_time'), value: 'StartTime' },
        {
          text: this.$t('discount_item_use_warranty_period'),
          value: 'UseWarrantyPeriods',
          sortable: false
        },
        { text: this.$t('quotation_item_remark'), value: 'Remark', sortable: false },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    overageDialogTitle () {
      return this.editedOverageIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    isLookMode () {
      return this.editedOverage.GroupOverageList.length !== 0
    },
    computeStartTime () {
      return this.convertToDateTimeFormat(this.editedOverage.StartTime)
    },
    allWarrantyPeriod () {
      let array = []
      let count = this.editedOverage.IsRepeat
        ? this.editedOverage.RepeatWarrantyPeriod
        : this.editedOverage.MonthWarrantyPeriod

      for (let index = 1; index <= count * 1; index++) {
        array.push(index)
      }
      return array
    },
    groupOverageItemDataTableHeaders () {
      return [
        { text: '已達預收條件', value: 'IsAchieve' },
        { text: '啟用期數', value: 'UseWarrantyPeriod' },
        { text: '啟用期數換算天數', value: 'UseOnDay' },
        { text: '已使用', value: 'IsCheckUse' },
        { text: '使用的銷貨單', value: 'UseSaleNumber' }
        // { text: this.$t('common_look'), value: 'Edit', sortable: false }
      ]
    },
    computedOverageRecordDataTableHeaders () {
      return [
        {
          text: this.$t('month_sale_item_start_date'),
          align: 'start',
          value: 'StartTime'
        },
        { text: this.$t('month_sale_item_end_date'), align: 'start', value: 'EndTime' },
        { text: this.$t('month_sale_item_pay_day'), align: 'end', value: 'UseDay' }
      ]
    },
    groupTitle () {
      return [
        { text: '', value: 'Sort' },
        { text: '', align: 'end', value: 'data-table-expand' }
      ]
    }
  },
  async mounted () {
    await this.getOverageList()
    await this.countTotalRows()
  },
  methods: {
    async setFilterCustomer (val) {
      this.filterOverage.CustomerId = val.Id
      this.filterOverage = JSON.parse(JSON.stringify(this.filterOverage))
      await this.getOverageList()
    },
    setGiveWarrantyPeriod () {
      this.editedOverage.GivePrepayment = this.editedOverage.UseWarrantyPeriods.length
    },
    async getMonthList () {
      let response = await HttpMonth.GetMonthList({
        customerId: this.editedOverage.CustomerId,
        licensePlate: this.editedOverage.LicensePlate
      })
      this.monthItemList = response.status === 200 ? response.data.Data : []
    },
    setKeyDownAutocomplete () {
      this.tempUseWarrantyPeriods = this.editedOverage.UseWarrantyPeriods
    },
    setKeyUpAutocomplete (event) {
      this.$refs.useWarrantyPeriodsAutocomplete.isMenuActive = false
      this.$refs.useWarrantyPeriodsAutocomplete.isFocused = false
      this.editedOverage.UseWarrantyPeriods = this.tempUseWarrantyPeriods
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    setStartTime (val) {
      this.editedOverage.StartTime = val * 1
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          MonthNumber: this.filterOverage.MonthNumber,
          CustomerId: this.filterOverage.CustomerId,
          LicensePlate: this.filterOverage.LicensePlate
        }
        let response = await HttpOverage.GetOverageCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    async updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      await this.getOverageList(val)
    },
    async getOverageList (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingOverage = true
      let param = {
        MonthNumber: this.filterOverage.MonthNumber,
        CustomerId: this.filterOverage.CustomerId,
        LicensePlate: this.filterOverage.LicensePlate,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy,
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy
      }
      let response = await HttpOverage.GetOverages(param)
      this.isLoadingOverage = false
      this.overageList = response.status === 200 ? response.data.Data : []
    },
    async setCustomer (val) {
      this.editedOverage.CustomerId = val.Id
      this.editedOverage.CustomerNumber = val.Number
      this.editedOverage.CustomerName = val.ShortName
      this.editedOverage.CustomerFullName = val.FullName
      this.editedOverage = JSON.parse(JSON.stringify(this.editedOverage))
    },
    setMonthItem (val) {
      this.editedOverage.MonthId = val.Id
      this.editedOverage.MonthNumber = val.Number
      this.editedOverage.MonthItemId = val.ItemId
      this.editedOverage.MonthItemNumber = val.ItemNumber
      this.editedOverage.MonthItemName = val.ItemName
      this.editedOverage.MonthWarrantyPeriod = val.RentWarrantyPeriod
      this.editedOverage = JSON.parse(JSON.stringify(this.editedOverage))
    },
    async isShowEditOverageDialogBtn (item) {
      this.editedOverageIndex = this.overageList.indexOf(item)
      this.editedOverage = JSON.parse(JSON.stringify(item))
      await this.getMonthList()
      this.isShowEditOverageDialog = true
    },
    closeEditDiscountDialog () {
      this.isShowEditOverageDialog = false
      this.$nextTick(() => {
        this.editedOverageIndex = -1
        this.editedOverage = JSON.parse(JSON.stringify(this.defaultOverage))
      })
    },
    async saveOverage () {
      const isValid = await this.$refs.dialogOverage.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        if (this.editedOverageIndex === -1) {
          await HttpOverage.AddOverage(this.editedOverage)
        } else {
          await HttpOverage.UpdateOverage(this.editedOverage)
        }
        this.isLoadingSaveBtn = false
        this.isAllTextFieldDisable = false
        await this.getOverageList()
        this.closeEditDiscountDialog()
      }
    },
    isShowDeleteOverageDialogBtn (item) {
      this.editedOverageIndex = this.overageList.indexOf(item)
      this.isShowDeleteOverageDialog = true
    },
    closeDeleteOverage () {
      this.editedOverageIndex = -1
      this.isShowDeleteOverageDialog = false
    },
    async confirmDeleteDiscount () {
      this.isLoadingSaveBtn = true
      this.isAllTextFieldDisable = true
      await HttpOverage.DeleteOverage(this.overageList[this.editedOverageIndex].Id)
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      await this.getOverageList()
      this.closeDeleteOverage()
    },

    combineText (item) {
      let orderNumber = ''
      let settleNumber = ''
      let prepaidNumber = ''
      if (item.OverageOrderNumber) {
        orderNumber = item.OverageOrderNumber
      }
      if (item.OverageSettleNumber) {
        settleNumber = item.OverageSettleNumber
      }
      if (item.OveragePrepaidNumber) {
        prepaidNumber = item.OveragePrepaidNumber
      }
      return (
        this.$t('discount_item_title') +
        item.Sort +
        this.$t('discount_item_title_second') +
        '　　　　' +
        this.$t('discount_item_title_time') +
        '　:　' +
        this.convertToDateTimeFormat(item.OverageStartTime) +
        '　　　　' +
        '預收訂單單號: ' +
        orderNumber +
        '　　　　' +
        '預收結帳單單號: ' +
        settleNumber +
        '　　　　' +
        '預收待抵單單號: ' +
        prepaidNumber
      )
    },

    openExpandRow (expand, isExpanded, index, item) {
      expand(!isExpanded)
      this.editedGroupSortObjIndex = index
      this.editedGroupSortObj = JSON.parse(JSON.stringify(item))
      console.log(this.editedGroupSortObjIndex)
      console.log(this.editedGroupSortObj)
    },
    closeExpandRow (expand, isExpanded) {
      expand(!isExpanded)
      this.editedGroupSortObjIndex = -1
      this.editedGroupSortObj = JSON.parse(JSON.stringify(this.defaultGroupSortObj))
      console.log(this.editedGroupSortObjIndex)
      console.log(this.editedGroupSortObj)
    },
    isShowCheckUseOverageDialogBtn (index, item) {
      this.isShowCheckUseOverageDialog = true
      this.editedGroupOverageItem = JSON.parse(JSON.stringify(item))
      this.editedGroupOverItemIndex = index
      console.log('index: ' + index)
      console.log(item)
    },
    async saveCheckUseOverage () {
      const isValid = await this.$refs.checkUseOverage.validate()
      if (isValid) {
        this.editedGroupOverageItem.IsCheckUse = true
        let sortObj = this.editedOverage.GroupOverageList[this.editedGroupSortObjIndex]
        sortObj.GroupOverageItemList[this.editedGroupOverItemIndex] = JSON.parse(
          JSON.stringify(this.editedGroupOverageItem)
        )
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        await HttpOverage.UpdateOverage(this.editedOverage)
        this.editedOverage = JSON.parse(JSON.stringify(this.editedOverage))
        this.closeCheckUseOverage()
      }
    },
    closeCheckUseOverage () {
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.isShowCheckUseOverageDialog = false
      this.editedGroupOverageItem = JSON.parse(JSON.stringify(this.defaultGroupOverageItem))
      this.editedGroupOverItemIndex = -1
    }
  }
}
</script>
